// Helper functions for hotel operations

import { hotelsAPI } from '../services/api';

/**
 * Handle edit hotel
 * @param {Object} hotel - The hotel object to edit
 * @param {Function} setEditingHotel - State setter for editing hotel
 * @param {Function} setHotelFormData - State setter for hotel form data
 * @param {Function} setShowHotelForm - State setter for showing hotel form
 * @param {Function} initializeHotelFormDataForEdit - Function to initialize hotel form data for edit
 */
export const handleEditHotel = (hotel, setEditingHotel, setHotelFormData, setShowHotelForm, initializeHotelFormDataForEdit) => {
  setEditingHotel(hotel);
  setHotelFormData(initializeHotelFormDataForEdit(hotel));
  setShowHotelForm(true);
};

/**
 * Handle delete hotel
 * @param {string} id - The hotel ID to delete
 * @param {Function} setErrors - State setter for errors
 * @param {Function} fetchHotels - Function to fetch hotels
 */
export const handleDeleteHotel = async (id, setErrors, fetchHotels) => {
  try {
    await hotelsAPI.delete(id);
    // Refresh the hotels list
    await fetchHotels();
  } catch (error) {
    console.error('Error deleting hotel:', error);
    setErrors(prev => ({ ...prev, deleteHotel: error.message || 'Failed to delete hotel' }));
  }
};

/**
 * Confirm delete hotel
 * @param {Object} hotel - The hotel object to delete
 * @param {Function} setHotelToDelete - State setter for hotel to delete
 * @param {Function} setShowDeleteConfirm - State setter for showing delete confirm
 */
export const confirmDeleteHotel = (hotel, setHotelToDelete, setShowDeleteConfirm) => {
  setHotelToDelete(hotel);
  setShowDeleteConfirm(true);
};

/**
 * Handle confirmed deletion
 * @param {Object} hotelToDelete - The hotel object to delete
 * @param {Function} setHotelToDelete - State setter for hotel to delete
 * @param {Function} setShowDeleteConfirm - State setter for showing delete confirm
 * @param {Function} setErrors - State setter for errors
 * @param {Function} fetchHotels - Function to fetch hotels
 */
export const handleConfirmDelete = async (hotelToDelete, setHotelToDelete, setShowDeleteConfirm, setErrors, fetchHotels) => {
  if (hotelToDelete) {
    try {
      await hotelsAPI.delete(hotelToDelete.id);
      // Refresh the hotels list
      await fetchHotels();
      // Close the confirmation popup
      setShowDeleteConfirm(false);
      setHotelToDelete(null);
    } catch (error) {
      console.error('Error deleting hotel:', error);
      setErrors(prev => ({ ...prev, deleteHotel: error.message || 'Failed to delete hotel' }));
      // Close the confirmation popup
      setShowDeleteConfirm(false);
      setHotelToDelete(null);
    }
  }
};

/**
 * Handle cancel deletion
 * @param {Function} setShowDeleteConfirm - State setter for showing delete confirm
 * @param {Function} setHotelToDelete - State setter for hotel to delete
 */
export const handleCancelDelete = (setShowDeleteConfirm, setHotelToDelete) => {
  setShowDeleteConfirm(false);
  setHotelToDelete(null);
};

export default {
  handleEditHotel,
  handleDeleteHotel,
  confirmDeleteHotel,
  handleConfirmDelete,
  handleCancelDelete
};